import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Records/hooks/useRecord.ts
function useRecord(args, opts = {}) {
	const { data, isCalling } = useRPC(RPCs.Records.GetRecordProfile.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: opts.fire || !!args?.recordId
	});
	return {
		data,
		loading: isCalling
	};
}
//#endregion
export { useRecord };

//# sourceMappingURL=useRecord.js.map